import { Typography, Container, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  useAcceptCallSheetInvitationMutation,
  useListCallSheetQuery,
  AcceptCallSheetInvitationDocument,
} from "../../../../../graphql/generated/graphql";
import config from "../../../../config/config";
import { useProjectsState } from "../../../../hooks/projectsInfo";
import ItemCallSheet from "../../../components/call-sheet/item";
import CallSheetModal from "../../../components/call-sheet/modal/modal";
import CallSheetModalParticipant from "../../../components/call-sheet/modalParticipant/modal";
import CircularLoading from "../../../components/common/CircularLoading";
import "./index.scss";
import { setAlertDescription } from "../../../../hooks/actions";
import { useLoginState } from "../../../../hooks/loginInfo";

const { URL_IMAGES } = config;

const CallSheetPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [acceptCallSheetInvitation] = useAcceptCallSheetInvitationMutation();
  const [callsheetId, setCallsheetId] = useState("");
  const [openSendModal, setOpenSendModal] = useState(false);
  const [canEditing] = useState(useLoginState().can_edit.get());
  const [openParticipantModal, setOpenParticipantModal] = useState(false);
  const projectsState = useProjectsState();
  const currentProject = projectsState.projectId.get();

  // to confirm callshet invitation from mail
  const user = searchParams.get("user");
  const callsheet = searchParams.get("callsheet");
  useEffect(() => {
    if (typeof user === "string" && typeof callsheet === "string") {
      acceptCallSheetInvitation({
        variables: {
          userId: user,
          callSheetId: callsheet,
        },
      }).then((res) => {
        setAlertDescription({
          open: true,
          message: `You have confirmed your attendance to the call sheet`,
          severity: "success",
        });
      });
    }
  }, []);
  //

  const {
    data: listCallSheet,
    loading,
    refetch,
  } = useListCallSheetQuery({
    variables: {
      project_id: currentProject || "",
    },
  });

  const handleOpenSendModal = (data: any) => {
    if (data.id) {
      setCallsheetId(data.id);
      setOpenSendModal(true);
    }
  };

  const handleOpenParticipantModal = (callsheetId: string) => {
    setOpenParticipantModal(true);
    setCallsheetId(callsheetId);
  };

  const handleCloseSendModal = () => setOpenSendModal(false);
  const handleCloseParticipantModal = () => setOpenParticipantModal(false);
  const callSheet = () => {
    if (listCallSheet) {
      return listCallSheet?.listCallSheet?.find(
        (item: any) => item.id === callsheetId
      );
      return null;
    }
  };

  return (
    <>
      <Typography
        component="p"
        variant="h1"
        className="title-section"
      >
        Call Sheet
        {canEditing &&
          <span className="subtitle-section">Create new call sheet</span>
        }
      </Typography>
      <Container
        sx={{
          width: "450px",
          maxWidth: "95%",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
        className="image-container"
      >
        <img
          width="100%"
          src={`${URL_IMAGES}call-sheet/new-call-sheet.svg`}
          alt="new-call-sheet"
        />
        {
          canEditing &&
          <Button
            sx={{
              width: "80%",
              transform: "translate(-50%, 0%)",
              left: "50%",
              fontSize: 30,
              position: "relative",
              bottom: "0",
            }}
            variant="contained"
            href="call-sheet/new"
            className="button-newcallsheet"
          >
            + New call sheet
          </Button>
        }
      </Container>
      <Container>
        {loading ? (
          <CircularLoading />
        ) : (
          listCallSheet &&
          listCallSheet.listCallSheet &&
          listCallSheet.listCallSheet.map((item, index: number) => (
            <ItemCallSheet
              key={item?.id || index}
              item={item as any}
              send={handleOpenSendModal}
              onOpenParticipant={handleOpenParticipantModal}
              onClose={handleCloseParticipantModal}
            />
          ))
        )}
      </Container>
      {callsheetId && (
        <CallSheetModalParticipant
          open={openParticipantModal}
          onOpen={handleOpenParticipantModal}
          id={callsheetId}
          onClose={handleCloseParticipantModal}
          callSheet={callSheet()}
          refetchListCallsheet={refetch}
        />
      )}
      <CallSheetModal
        open={openSendModal}
        id={callsheetId}
        onClose={handleCloseSendModal}
        refetch={refetch}
        onlySent={true}
      />
    </>
  );
};

export default CallSheetPage;
